module.exports = function() {
  return new Worker(__webpack_public_path__ + "2f4600fed86a26203b8e.worker.js");
};